import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  locations,
  projectList,
  bbsCreate,
  bbsList,
  projectCount,
  approverDashboard,
  viewProject,
  managerDashboard,
  managerApproveProject,
  managerApproveUser,
  fetchApproveReject,
  newBBS,
  BBSView,
  projectCountDashboard,
  optimizationCountDashboard,
  managerProjectCountDashboard,
  managerOptimizationCountDashboard,
  bbsInactivate,
  getBbs,
  leaderShipDashboard,
  leaderShipTableData,
  leaderShipManagerTableData,
  finalBBSOutput,
  inputFiles,
  leaderShipDashboard_MANAGER
} from './api';
import { message } from 'antd';

const initialState = {
  allProjectList: [],
  locations: [],
  bbsList: [],
  approverpagination:{},
  projectCount: [],
  approverDashboard:[],
  managerDashboard:[],
  fetchApproveReject:[],
  BBSView:{},
  viewProject:[],
  loading: false,
  projectData: null,
  newBBSData:[],
  newBBSpagination:{},
  projectCountDashboard:{},
  optimizationCountDashboard:{},
  managerProjectCountDashboard:[],
  managerOptimizationCountDashboard:[],
  getBbsData:[],
  leaderShipDashboard:[],
  leaderShipTableData:[],
  leaderShipManagerTableData:[],
  finalBBSOutput:[],
  inputFiless:[],
  newBBSMessage:''
};

const actions = {
  GET_PROJECT_LIST: 'GET_PROJECT_LIST',
  GET_LOCATIONS: 'GET_LOCATIONS',
  BBS_CREATE: 'BBS_CREATE',
  GET_BBS_LIST: 'GET_BBS_LIST',
  GET_PROJECT_COUNT: 'GET_PROJECT_COUNT',
  GET_MANAGER_PROJECT_COUNT:'GET_MANAGER_PROJECT_COUNT',
  GET_MANAGER_OPTIMIZATION_COUNT:'GET_MANAGER_OPTIMIZATION_COUNT',
  GET_APPROVER_DASHBOARD:'GET_APPROVER_DASHBOARD',
  VIEW_PROJECT:'VIEW_PROJECT',
  GET_MANAGER_DASHBOARD:'GET_MANAGER_DASHBOARD',
  MANAGER_APPROVE_PROJECT:'MANAGER_APPROVE_PROJECT',
  MANAGER_APPROVE_USER:'MANAGER_APPROVE_USER',
  FETCH_APPROVE_REJECT:'FETCH_APPROVE_REJECT',
  CREATE_NEW_BBS:'CREATE_NEW_BBS',
  BBS_VIEW:'BBS_VIEW',
  FETCH_PROJECT_COUNT_DASHBOARD_DATA:' FETCH_PROJECT_COUNT_DASHBOARD_DATA',
  FETCH_OPTIMIZATION_COUNT_DASHBOARD_DATA:'FETCH_OPTIMIZATION_COUNT_DASHBOARD_DATA',
  INACTIVE_BBS:'INACTIVE_BBS',
  GET_BBS_DATA:'GET_BBS_DATA',  
  LEADERSHIP_DASHBOARD:'LEADERSHIP_DASHBOARD', 
  LEADERSHIP_DASHBOARD_MANAGER:'LEADERSHIP_DASHBOARD_MANAGER', 
  LEADERSHIP_TABLE_DATA:'LEADERSHIP_TABLE_DATA',
  LEADERSHIP_MANAGER_TABLE_DATA:'LEADERSHIP_MANAGER_TABLE_DATA',
  FINAL_BBS_OUTPUT:'FINAL_BBS_OUTPUT',
  GET_INPUT_FILES:'GET_INPUT_FILES'
};

export const getProjectList = createAsyncThunk(
  actions.GET_PROJECT_LIST,
  async (payload) => {
    const response = await projectList(payload);
    return response;
  },
);

export const getLocations = createAsyncThunk(
  actions.GET_LOCATIONS,
  async (payload) => {
    const response = await locations(payload);
    return response;
  },
);

export const createBbs = createAsyncThunk(
  actions.BBS_CREATE,
  async (payload) => {
    const response = await bbsCreate(payload);
    return response;
  },
);

export const getBbsList = createAsyncThunk(
  actions.GET_BBS_LIST,
  async (payload = {}) => {
    const { currentPage = 1, pageSize = 7 } = payload; // Set default values
    const response = await bbsList({ currentPage, pageSize });
    return response;
  },
);
export const getProjectCount = createAsyncThunk(
  actions.GET_PROJECT_COUNT,
  async (payload) => {
    const response = await projectCount(payload);
    return response;
  },
);

export const getManagerProjectCount = createAsyncThunk(
  actions.GET_MANAGER_PROJECT_COUNT,
  async (payload) => {
    const response = await managerProjectCountDashboard(payload);
    return response;
  },
);


export const getManagerOptimizationCount = createAsyncThunk(
  actions.GET_MANAGER_OPTIMIZATION_COUNT,
  async (payload) => {
    const response = await managerOptimizationCountDashboard(payload);
    return response;
  },
);


  export const getApproverDashboard = createAsyncThunk(
    actions.GET_APPROVER_DASHBOARD,
    async (payload) => {
      const response = await approverDashboard(payload);
      return response;
    },
  );

export const getViewProject = createAsyncThunk(
  actions.VIEW_PROJECT,
  async ({ projectCode }, thunkAPI) => {
    try {
      const response = await viewProject(projectCode); // Pass only the projectCode
      return response; // Ensure response data is returned
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getManagerDashboard = createAsyncThunk(
  actions.GET_MANAGER_DASHBOARD,
  async (payload) => {
    const response = await managerDashboard(payload);
    return response;
  },
);

export const createManagerApproveProject = createAsyncThunk(
  actions.MANAGER_APPROVE_PROJECT,
  async (payload) => {
    const response = await managerApproveProject(payload);
    return response;
  },
);

export const createManagerApproveUser = createAsyncThunk(
  actions.MANAGER_APPROVE_USER,
  async (payload) => {
    const response = await managerApproveUser(payload);
    return response;
  },
);

export const getApproveReject = createAsyncThunk(
  actions.FETCH_APPROVE_REJECT,
  async (payload) => {
    console.log('testing slice: ', payload.id);
    // No default values for currentPage and pageSize; they come from the backend
    const response = await fetchApproveReject(payload.id); 
    return response;
  }
);

export const getBBSView = createAsyncThunk(
  actions.BBS_VIEW,
  async (payload) => {
    //console.log('testing slice: ', payload.id);
    // No default values for currentPage and pageSize; they come from the backend
    const response = await BBSView(payload.id); 
    return response;
  }
);
export const createNewBBS = createAsyncThunk(
  actions.CREATE_NEW_BBS,
  async (payload) => {
    const response = await newBBS(payload);
    return response;
  },
);

export const fetchProjectCountDashboard = createAsyncThunk(
  actions.FETCH_PROJECT_COUNT_DASHBOARD_DATA,
  async (payload) => {
    const response = await projectCountDashboard(payload);
    return response;
  },
);

export const fetchOptimizatonCountDashboard = createAsyncThunk(
  actions.FETCH_OPTIMIZATION_COUNT_DASHBOARD_DATA,
  async (payload) => {
    const response = await optimizationCountDashboard(payload);
    return response;
  },
);

export const inactiveBbs = createAsyncThunk(
  actions.INACTIVE_BBS,
  async (payload) => {
    console.log('payload', payload);
    const response = await bbsInactivate(payload); 
    return response;
  },
);

export const getBBsDetails = createAsyncThunk(
  actions.GET_BBS_DATA,
  async (payload) => {
    console.log('payload', payload);
    const response = await getBbs(payload); 
    return response;
  },
);

export const getLeaderShipDashboard = createAsyncThunk(
  actions.LEADERSHIP_DASHBOARD,
  async (payload) => {
    //console.log('payload', payload);
    const response = await leaderShipDashboard(payload); 
    return response;
  },
);

export const getLeaderShipDashboard_Manager = createAsyncThunk(
  actions.LEADERSHIP_DASHBOARD_MANAGER,
  async (payload) => {
    //console.log('payload', payload);
    const response = await leaderShipDashboard_MANAGER(payload); 
    return response;
  },
);

export const createLeadershipTableData = createAsyncThunk(
  actions.LEADERSHIP_TABLE_DATA,
  async (payload) => {
    const response = await leaderShipTableData(payload);
    return response;
  },
);

export const getLeaderShipTableManagerData = createAsyncThunk(
  actions.LEADERSHIP_MANAGER_TABLE_DATA,
  async (payload) => {
    const response = await leaderShipManagerTableData(payload);
    return response;
  },
);

export const getFinalBBSOutput = createAsyncThunk(
  actions.FINAL_BBS_OUTPUT,
  async (payload) => {
    const response = await finalBBSOutput(payload);
    return response;
  },
);

export const getInputFiles = createAsyncThunk(
  actions.GET_INPUT_FILES,
  async (payload) => {
    const response = await inputFiles(payload);
    return response;
  },
);




export const projectListSlice = createSlice({
  name: 'projectList',
  initialState,
  reducers: {
    setProjectData: (state, action) => {
      state.projectData = action.payload; // Store the response in the Redux store
    },
    // setnewBBSData:(state,action)=>{
    //   state.newBBSData=action.payload;
    // }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProjectList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProjectList.fulfilled, (state, action) => {
        state.loading = false;
        state.allProjectList = action.payload;
      })
      .addCase(getProjectList.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.loading = false;
        message.error(msg);
      });
    builder
      .addCase(getLocations.pending, (state) => {
        state.loading = true;
      })
      .addCase(getLocations.fulfilled, (state, action) => {
        state.loading = false;
        state.locations = action.payload;
      })
      .addCase(getLocations.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.loading = false;
        message.error(msg);
      });

    builder
      .addCase(createBbs.pending, (state) => {
        state.loading = true;
      })
      .addCase(createBbs.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createBbs.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.loading = false;
        message.error(msg);
      });

    builder
      .addCase(getBbsList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBbsList.fulfilled, (state, action) => {
        state.loading = false;
        state.bbsList = action.payload;
      })
      .addCase(getBbsList.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.loading = false;
        message.error(msg);
      });

    builder
      .addCase(getProjectCount.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProjectCount.fulfilled, (state, action) => {
        state.loading = false;
        state.projectCount = action.payload;
      })
      .addCase(getProjectCount.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.loading = false;
        message.error(msg);
      });


      builder
      .addCase(getManagerProjectCount.pending, (state) => {
        state.loading = true;
      })
      .addCase(getManagerProjectCount.fulfilled, (state, action) => {
        state.loading = false;
        state.managerProjectCountDashboard = action.payload;
      })
      .addCase(getManagerProjectCount.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.loading = false;
        message.error(msg);
      });

      builder
      .addCase(getManagerOptimizationCount.pending, (state) => {
        state.loading = true;
      })
      .addCase(getManagerOptimizationCount.fulfilled, (state, action) => {
        state.loading = false;
        state.managerOptimizationCountDashboard = action.payload;
      })
      .addCase(getManagerOptimizationCount.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.loading = false;
        message.error(msg);
      });

      
      builder
      .addCase(getApproverDashboard.pending, (state) => {
        state.loading = true;
      })
      .addCase(getApproverDashboard.fulfilled, (state, action) => {
        state.loading = false;
        state.approverpagination=action.payload.paginationInfo||{};
        state.approverDashboard = action.payload.data;
      })
      .addCase(getApproverDashboard.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.loading = false;
        message.error(msg);
      });

      builder
      .addCase(getViewProject.pending, (state) => {
        state.loading = true;
      })
      .addCase(getViewProject.fulfilled, (state, action) => {
        console.log('action ',action)
        state.viewProject = action.payload;
        state.loading = false;
      })
      .addCase(getViewProject.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.loading = false;
        //message.error(msg);
      });

      builder
      .addCase(getManagerDashboard.pending, (state) => {
        state.loading = true;
      })
      .addCase(getManagerDashboard.fulfilled, (state, action) => {
        state.loading = false;
        state.pagination=action.payload.paginationInfo
        state.managerDashboard = action.payload.data;
        //state.managerDashboard = action.payload;
      })
      .addCase(getManagerDashboard.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.loading = false;
        //message.error(msg);
      });

      builder
      .addCase(createManagerApproveProject.pending, (state) => {
        state.loading = true;
      })
      .addCase(createManagerApproveProject.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createManagerApproveProject.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.loading = false;
        message.error(msg);
      });


      builder
      .addCase(createManagerApproveUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(createManagerApproveUser.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createManagerApproveUser.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.loading = false;
        message.error(msg);
      });

      builder
      .addCase(getApproveReject.pending, (state) => {
        state.loading = true;
      })
      .addCase(getApproveReject.fulfilled, (state, action) => {
        state.loading = false;
        state.fetchApproveReject = action.payload;
      })
      .addCase(getApproveReject.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.loading = false;
        message.error(msg);
      });

      builder
      .addCase(getBBSView.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBBSView.fulfilled, (state, action) => {
        state.loading = false;
        state.BBSView = action.payload.view;
      })
      .addCase(getBBSView.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.loading = false;
        message.error(msg);
      });

  
      builder
      .addCase(createNewBBS.pending, (state) => {
        state.loading = true;
      })
      .addCase(createNewBBS.fulfilled, (state, action) => {
        state.newBBSpagination=action.payload.paginationInfo||{};
        state.newBBSData = action.payload.data;
        state.newBBSMessage=action.payload.message
        state.loading = false;
      })
      .addCase(createNewBBS.rejected, (state, action) => {
        // Ensure the error is a simple message and doesn't contain complex objects
        const errorMessage = action.error?.message || 'An unknown error occurred';
        
        state.loading = false;
        message.error(errorMessage);  // Show the error message
  
        // Log only the message for debugging
        console.error('API call failed:', errorMessage);
      });

      builder
      .addCase(fetchProjectCountDashboard.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchProjectCountDashboard.fulfilled, (state, action) => {
        state.projectCountDashboard = action.payload;
        state.loading = false;
      })
      .addCase(fetchProjectCountDashboard.rejected, (state, action) => {
        // Ensure the error is a simple message and doesn't contain complex objects
        const errorMessage = action.error?.message || 'An unknown error occurred';
        
        state.loading = false;
        message.error(errorMessage);  // Show the error message
  
        // Log only the message for debugging
        console.error('API call failed:', errorMessage);
      });

      builder
      .addCase(fetchOptimizatonCountDashboard.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchOptimizatonCountDashboard.fulfilled, (state, action) => {
        state.optimizationCountDashboard = action.payload;
        state.loading = false;
      })
      .addCase(fetchOptimizatonCountDashboard.rejected, (state, action) => {
        // Ensure the error is a simple message and doesn't contain complex objects
        const errorMessage = action.error?.message || 'An unknown error occurred';
        
        state.loading = false;
        message.error(errorMessage);  // Show the error message
  
        // Log only the message for debugging
        console.error('API call failed:', errorMessage);
      });

       builder
            .addCase(inactiveBbs.pending, (state) => {
              state.loading = true;
            })
            .addCase(inactiveBbs.fulfilled, (state, action) => {
              state.loading = false;
            })
            .addCase(inactiveBbs.rejected, (state, action) => {
              const { message: msg } = action.error;
              state.loading= false;
              //message.error(msg);
            });

            builder
            .addCase(getBBsDetails.pending, (state) => {
              state.loading = true;
            })
            .addCase(getBBsDetails.fulfilled, (state, action) => {
              state.loading = false;
              state.getBbsData = action.payload;
            })
            .addCase(getBBsDetails.rejected, (state, action) => {
              const { message: msg } = action.error;
              state.loading= false;
              //message.error(msg);
            });

            builder
            .addCase(getLeaderShipDashboard.pending, (state) => {
              state.loading = true;
            })
            .addCase(getLeaderShipDashboard.fulfilled, (state, action) => {
              state.loading = false;
              state.leaderShipDashboard = action.payload;
            })
            .addCase(getLeaderShipDashboard.rejected, (state, action) => {
              const { message: msg } = action.error;
              state.loading= false;
              //message.error(msg);
            });

            builder
            .addCase(getLeaderShipDashboard_Manager.pending, (state) => {
              state.loading = true;
            })
            .addCase(getLeaderShipDashboard_Manager.fulfilled, (state, action) => {
              state.loading = false;
              state.leaderShipDashboard = action.payload;
            })
            .addCase(getLeaderShipDashboard_Manager.rejected, (state, action) => {
              const { message: msg } = action.error;
              state.loading= false;
              //message.error(msg);
            });

            builder
            .addCase(createLeadershipTableData.pending, (state) => {
              state.loading = true;
            })
            .addCase(createLeadershipTableData.fulfilled, (state, action) => {
              state.loading = false;
              state.leaderShipTableData= action.payload;
            })
            .addCase(createLeadershipTableData.rejected, (state, action) => {
              const { message: msg } = action.error;
              state.loading= false;
              //message.error(msg);
            });

            builder
            .addCase(getLeaderShipTableManagerData.pending, (state) => {
              state.loading = true;
            })
            .addCase(getLeaderShipTableManagerData.fulfilled, (state, action) => {
              state.loading = false;
              state.leaderShipManagerTableData= action.payload;
            })
            .addCase(getLeaderShipTableManagerData.rejected, (state, action) => {
              const { message: msg } = action.error;
              state.loading= false;
              //message.error(msg);
            });

            
            builder
            .addCase(getFinalBBSOutput.pending, (state) => {
              state.loading = true;
            })
            .addCase(getFinalBBSOutput.fulfilled, (state, action) => {
              state.loading = false;
              state.finalBBSOutput= action.payload;
            })
            .addCase(getFinalBBSOutput.rejected, (state, action) => {
              const { message: msg } = action.error;
              state.loading= false;
              //message.error(msg);
            });

            builder
            .addCase(getInputFiles.pending, (state) => {
              state.loading = true;
            })
            .addCase(getInputFiles.fulfilled, (state, action) => {
              state.loading = false;
              state.inputFiless= action.payload;
            })
            .addCase(getInputFiles.rejected, (state, action) => {
              const { message: msg } = action.error;
              state.loading= false;
              //message.error(msg);
            });

  },

  
});

export const { setProjectData} = projectListSlice.actions;

export default projectListSlice.reducer;
